import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-login-details.reducer';

export const UserLoginDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userLoginDetailsEntity = useAppSelector(state => state.userLoginDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userLoginDetailsDetailsHeading">
          <Translate contentKey="fivePlusApp.userLoginDetails.detail.title">UserLoginDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userLoginDetailsEntity.id}</dd>
          <dt>
            <span id="lastLogin">
              <Translate contentKey="fivePlusApp.userLoginDetails.lastLogin">Last Login</Translate>
            </span>
          </dt>
          <dd>
            {userLoginDetailsEntity.lastLogin ? (
              <TextFormat value={userLoginDetailsEntity.lastLogin} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="isActive">
              <Translate contentKey="fivePlusApp.userLoginDetails.isActive">Is Active</Translate>
            </span>
          </dt>
          <dd>{userLoginDetailsEntity.isActive ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.userLoginDetails.user">User</Translate>
          </dt>
          <dd>{userLoginDetailsEntity.user ? userLoginDetailsEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-login-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-login-details/${userLoginDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserLoginDetailsDetail;
